export default __webpack_public_path__ + "static/media/4.098fda61.png";